var map = {
	"./Ascendure Logo.png": 7309,
	"./Blog 1.png": 7341,
	"./Blog 2.png": 6134,
	"./Bottom CTA Image.png": 8320,
	"./Channel Partner Image.png": 4330,
	"./Dubai Banner.png": 8303,
	"./Dubai Container Image.png": 3599,
	"./Feature Countries Image.png": 345,
	"./Hero Section Image.png": 3746,
	"./KSA Banner.png": 2063,
	"./KSA Container Image.png": 223,
	"./Lifestyle Home Image.png": 4065,
	"./Luxury Villas Image.png": 8791,
	"./Montenegro Banner.png": 7182,
	"./Montenegro Container Image.png": 6636,
	"./Off Plan Icons Image.png": 6673,
	"./Rectangle 47.png": 9306,
	"./Rectangle 59.png": 1115,
	"./Redefining Modern Image.png": 4085,
	"./Residency Eligible Image.png": 2424,
	"./Spain Banner.png": 4063,
	"./Spain Container Image.png": 4655,
	"./WhatsApp Image 2025-10-15 at 4.12.18 PM.jpeg": 1950,
	"./WhatsApp Image 2025-10-15 at 4.12.19 PM (1).jpeg": 697,
	"./WhatsApp Image 2025-10-15 at 4.12.19 PM.jpeg": 3123,
	"./WhatsApp Image 2025-10-15 at 4.12.26 PM (1).jpeg": 2147,
	"./WhatsApp Image 2025-10-15 at 4.12.26 PM (2).jpeg": 9220,
	"./WhatsApp Image 2025-10-15 at 4.12.26 PM (3).jpeg": 4785,
	"./WhatsApp Image 2025-10-15 at 4.12.26 PM.jpeg": 8013,
	"./c89a2b62b84dc8f6fac7a053ed833294 1.png": 8199,
	"./customer 1.png": 8789,
	"./expertise 1.png": 2834,
	"./favicon.png": 7514,
	"./global 1.png": 3116,
	"./home (3) 1.jpg": 1924,
	"./tall-city-building-on-isolated-transparent-background-free-png 1.png": 6920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7712;